import mousetrap from 'mousetrap'

export default function(o){

  console.log('clearShortcuts');

  mousetrap.unbind('mod+shift+right')

  mousetrap.unbind('shift+right')

  mousetrap.unbind('right')

  mousetrap.unbind('mod+shift+left')

  mousetrap.unbind('shift+left')

  mousetrap.unbind('left')

  mousetrap.unbind('space')

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/app/clearShortcuts.js